import view from '@/mixins/view'

import RAF from '@/js/utils/raf'
import PhilosophyScene from '@/glxp/scenes/philosophyScene'
import WebglManager from '@/glxp/webglManager'
import TweenMax from 'gsap/TweenMax'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

export default {
  name: 'tpl-manifest',
  mixins: [view],
  data () {
    return {
      page: null,
      bgc: {
        backgroundColor: '#C95032'
      },
      scrolling: false,
      scrollValue: 0,
      currentSection: 0,
      lastY: 0
    }
  },
  created () {
    this.getPage().then(() => {
      if (!this.page) this.$router.push({ name: 'not-found' })
      this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
      this.preloadAssets().then(() => {
        this.bgc.backgroundColor = this.page.meta.manifest[0].background_color

        this.ready = true

        this.$nextTick(() => {
          let vh = window.innerHeight * 0.01
          document.documentElement.style.setProperty('--phi', `${vh}px`)
          this.initWebglXP()
          RAF.suscribe('manifest-webgl', this.updateWebgl.bind(this))
          this.getSectionScroll()
          RAF.suscribe('manifest', this.update.bind(this))
          document.addEventListener('mousewheel', this.handleScroll)
          window.addEventListener('DOMMouseScroll', this.handleScroll)
          document.addEventListener('touchstart', this.touchStart)
          document.addEventListener('touchmove', this.handleTouch)
          window.addEventListener('resize', this.resize)
          this.currentSection = 0
          document.documentElement.classList.add('preventScroll')
        })
      })
    })
  },
  beforeDestroy () {
    WebglManager.desactivate('philosophy')
    RAF.unsuscribe('manifest')
    RAF.unsuscribe('manifest-webgl')
    document.removeEventListener('mousewheel', this.handleScroll)
    document.removeEventListener('DOMMouseScroll', this.handleScroll)
    document.removeEventListener('touchstart', this.touchStart)
    document.removeEventListener('touchmove', this.handleTouch)
    window.removeEventListener('resize', this.resize)
    document.documentElement.classList.remove('preventScroll')
  },
  destroyed () {
    WebglManager.desactivate('philosophy')
    RAF.unsuscribe('manifest')
    RAF.unsuscribe('manifest-webgl')
    document.removeEventListener('mousewheel', this.handleScroll)
    document.removeEventListener('DOMMouseScroll', this.handleScroll)
    document.removeEventListener('touchstart', this.touchStart)
    document.removeEventListener('touchmove', this.handleTouch)
    document.documentElement.classList.remove('preventScroll')
  },
  methods: {
    fetchData: async function (store, params) {
      return Promise.all([
        store.getters.get('page', params.post_id)
      ]).then(([page]) => {
        return { page }
      })
    },
    preloadAssets: async function () {
      return Promise.all(this.page.meta.manifest.map(m => {
        return this.fetch(this.getCleanLink(this.getImageUrl(m.image)))
      }))
    },
    getPage: async function () {
      await this.fetchData(this.$store, this.$attrs).then(({ page }) => {
        this.page = page
      })
    },
    initWebglXP () {
      this.glxp = WebglManager.getScene('philosophy')

      this.glxp.setTitles(this.page.meta.manifest.map(m => this.getImageUrl(m.image)))

      WebglManager.loadScene('philosophy')
      WebglManager.activate('philosophy')
      this.$nextTick(() => {
        this.$nextTick(() => {
          WebglManager.recomputeBounds()
        })
      })
      WebglManager.setStyle({
        zIndex: 2,
        pointerEvents: 'all'
      })
    },
    getSectionScroll () {
      let sections = this.$el.querySelectorAll('.manifest-content-section ')
      this.sectionsScroll = []
      this.height = window.innerHeight
      for (let i = 0; i < sections.length; i++) {
        const s = sections[i]
        this.sectionsScroll.push({
          dom: s,
          offset: s.getBoundingClientRect().top
        })
      }
    },
    update () {
      let scroll = this.scrollValue
      let selectedColor
      for (let i = 0; i < this.sectionsScroll.length; i++) {
        const sectionScroll = this.sectionsScroll[i]
        if ((scroll + this.height * 0.7) > sectionScroll.offset) {
          selectedColor = sectionScroll.dom.dataset.color
        }
      }
      this.bgc.backgroundColor = selectedColor
      this.updateScroll()
    },
    updateWebgl () {
      // this.glxp.render()
    },
    handleScroll (e) {
      let way
      // pageYOffset > this.lastPageOffset ? way = 'down' : way = 'up'
      this.isFirefox ? e.detail < 0 ? way = 'up' : way = 'down' : e.deltaY > 0 ? way = 'down' : way = 'up'

      if (window.pageYOffset <= 0 && this.currentSection === 2 && way === 'up') {
        document.documentElement.classList.add('preventScroll')
      }
      if (this.scrolling || (window.pageYOffset || document.documentElement.scrollTop) !== 0) {
      } else {
        this.scrolling = true
        way === 'down' ? this.currentSection++ : this.currentSection--
        this.scrollTo()
      }
    },
    updateScroll () {
      if (this.$refs['block-container']._gsTransform) this.scrollValue = -this.$refs['block-container']._gsTransform.y + (window.pageYOffset || document.documentElement.scrollTop)
    },
    touchStart (e) {
      this.lastY = e.targetTouches[0].pageY
    },
    handleTouch (e) {
      var currentY = e.targetTouches[0].pageY
      if (window.pageYOffset <= 0 && this.currentSection === 2 && currentY > this.lastY) {
        document.documentElement.classList.add('preventScroll')
        window.scrollTo(0, 0)
        this.scrolling = false
      }

      if (this.scrolling || (window.pageYOffset) !== 0) return
      this.scrolling = true

      if (currentY > this.lastY) {
        this.currentSection--
        this.scrollTo()
      } else if (currentY < this.lastY) {
        this.currentSection++

        this.scrollTo()
      }
    },
    scrollTo () {
      if (this.currentSection > 2) {
        this.currentSection = 2
      } else if (this.currentSection < 0) {
        this.currentSection = 0
      }
      if (this.currentSection < 2) document.documentElement.classList.add('preventScroll')
      TweenMax.to(this.$refs['block-container'], 1, {
        y: -this.$refs['manifest-section'][0].getBoundingClientRect().height * this.currentSection,
        ease: Power2.easeOut,
        onUpdate: () => {
        },
        onComplete: () => {
          this.scrolling = false
          if ((window.pageYOffset || document.documentElement.scrollTop) <= 0) {
            // this.currentSection === 2 ? document.documentElement.classList.remove('preventScroll') : document.documentElement.classList.add('preventScroll')
          }
        }
      })
    },
    resize () {
      if (this.$store.state.ua.platform.type === 'desktop') {
        let sections = this.$el.querySelectorAll('.manifest-content-section ')
        this.height = window.innerHeight
        this.getSectionScroll()
        TweenMax.set(this.$refs['block-container'], { y: -this.$refs['manifest-section'][0].getBoundingClientRect().height * this.currentSection })
      }
    }
  }
}
